// extracted by mini-css-extract-plugin
export default {"socialLink":"SocialLinks__socialLink__xRCaD"};